<div class="dialog-body">
  <div class="close-btn-outer">
    <button mat-mini-fab color="warn" (click)="this.dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <form [formGroup]="formData">
    <div mat-dialog-content>
      <div fxLayout="row wrap">
        <div *ngIf="this.id != 0" fxFlex="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label> {{ "ACCOUNT.NAME" | translate }}</mat-label>
            <input
              matInput
              [placeholder]="'TRANSLATE.OFFICE_HOME' | translate"
              type="text"
              required
              formControlName="name"
            />
            <mat-error *ngIf="formData.get('name')?.hasError('required')">
              {{ "TRANSLATE.REQEUIRED_FIELD" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex.gt-sm="50" fxFlex="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label> {{ "TRANSLATE.DEPARTAMENT" | translate }}</mat-label>
            <span matSuffix *ngIf="loadDepartment">
              <mat-progress-spinner [diameter]="20" mode="indeterminate">
              </mat-progress-spinner>
            </span>
            <mat-select
              formControlName="location_one"
              (selectionChange)="onChangeDepartment()"
              required
            >
              <mat-option>
                <ngx-mat-select-search
                  [(ngModel)]="searchDepartment"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="changueOptionsDepartment($event)"
                  [placeholderLabel]="'TRANSLATE.SEARCH' | translate"
                  [noEntriesFoundLabel]="
                    'TRANSLATE.NO_FOUND_MATCHES' | translate
                  "
                >
                </ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let item of listFilterDepartment"
                [value]="item.code"
              >
                {{ item.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="formData.get('location_one')?.hasError('required')"
            >
              {{ "TRANSLATE.REQEUIRED_FIELD" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex.gt-sm="50" fxFlex="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label> {{ "TRANSLATE.CITY" | translate }}</mat-label>
            <span matSuffix *ngIf="loadCity">
              <mat-progress-spinner [diameter]="20" mode="indeterminate">
              </mat-progress-spinner>
            </span>
            <mat-select
              formControlName="location_two"
              (selectionChange)="onChangeCitys()"
              required
            >
              <mat-option>
                <ngx-mat-select-search
                  [(ngModel)]="searchCity"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="changueOptionsCity($event)"
                  [placeholderLabel]="'TRANSLATE.SEARCH' | translate"
                  [noEntriesFoundLabel]="
                    'TRANSLATE.NO_FOUND_MATCHES' | translate
                  "
                >
                </ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let item of listFilterCity"
                [value]="item.code"
              >
                {{ item.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="formData.get('location_two')?.hasError('required')"
            >
              {{ "TRANSLATE.REQEUIRED_FIELD" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row">
        <div fxFlex="100" class="px-1">
          <div
            fxLayout="row"
            fxLayout.xs="column"
            class="d-flex justify-content-between align-items-start flex-row flex-xs-column text-muted"
          >
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ "TRANSLATE.ADDRESS" | translate }}</mat-label>
              <input
                matInput
                [placeholder]="'TRANSLATE.COLONY_BLOCK_HOUSE' | translate"
                type="text"
                required
                formControlName="address"
                required
              />
              <mat-hint>{{
                "TRANSLATE.COLONY_BLOCK_HOUSE" | translate
              }}</mat-hint>
              <mat-error *ngIf="formData.get('address')?.hasError('required')">
                {{ "TRANSLATE.REQEUIRED_FIELD" | translate }}
              </mat-error>
              <mat-error *ngIf="formData.get('address')?.hasError('maxlength')">
                {{ "TRANSLATE.MAX_250_CHARACTERS" | translate }}
              </mat-error>
            </mat-form-field>
            <div>
              <button
                mat-button
                color="{{
                  this.formData.value.latitude == null ||
                  this.formData.value.latitude == '0.0'
                    ? 'warn'
                    : 'primary'
                }}"
                (click)="openMap()"
                #tooltip="matTooltip"
                [matTooltip]="
                  (this.formData.value.latitude == null ||
                  this.formData.value.latitude == '0.0'
                    ? 'TRANSLATE.PLEASE_CURRECT_LOCATION'
                    : 'TRANSLATE.CURRENT_LOCATION_CHANGE'
                  ) | translate
                "
                matTooltipPosition="below"
                matTooltipClass="allow-cr"
              >
                <div fxLayout="column" fxLayoutAlign="center center">
                  <!-- <mat-icon style="font-size:40px"> near_me</mat-icon> -->
                  <span>{{
                    this.formData.value.latitude == null ||
                    this.formData.value.latitude == "0.0"
                      ? "TRANSLATE.CURRENT_LOCATION"
                      : ("TRANSLATE.EDIT_LOCATION" | translate)
                  }}</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div fxLayout="row wrap" style="margin-top: 6px">
        <div fxFlex="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ "TRANSLATE.REFERENCE" | translate }}</mat-label>
            <input
              matInput
              [placeholder]="'TRANSLATE.BENCHMARK' | translate"
              type="text"
              formControlName="reference"
              required
            />
            <mat-error *ngIf="formData.get('reference')?.hasError('required')">
              {{ "TRANSLATE.REQEUIRED_FIELD" | translate }}
            </mat-error>
            <mat-error *ngIf="formData.get('reference')?.hasError('maxlength')">
              {{ "TRANSLATE.MAX_250_CHARACTERS" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <mat-dialog-actions fxLayoutAlign="end">
      <button mat-raised-button (click)="this.dialogRef.close()">
        {{ "TRANSLATE.CANCEL" | translate }}
      </button>
      <button
        type="submit"
        mat-raised-button
        class="mrgn-l-md"
        style="background-color: #d62300; color: white"
        (click)="onSubmit()"
      >
        {{ "TRANSLATE.SAVE" | translate }}
      </button>
    </mat-dialog-actions>
  </form>
</div>
